import { FC, memo } from "react";
import { EditOrderTemplateProps } from "./EditPackage.interface";
import { EditPackage } from "@/components/pages/Packages";
import { Modal } from "@/components/molecules";


const EditPackageModal : FC<EditOrderTemplateProps> = ({
    loading,
    orderTemplate,
    onClose,
    onSaveTemplate
}) => {

    return (<Modal minWidth="800px" onClose={onClose} title="Edit Package">
              <EditPackage
                orderTemplate={orderTemplate}
                onCancel={onClose}
                onSaveTemplate={onSaveTemplate}
              />
            </Modal>);
}

export default memo(EditPackageModal);